import React from "react";
import { FeatureFlagsQuery } from "services/graphql/generated";
import { AppContextInterface } from "types/appContext";

export const AppContext = React.createContext<AppContextInterface>({
  featureFlags: [],
  tenant: null,
  updateFeatureFlags: (_flags: FeatureFlagsQuery["featureFlags"]) => {},
});
